// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1o_UE","search":"Settings_search__3oadV","filter":"Settings_filter__2E2aR"};